<template>
    <div>
    	 <router-view/>
		  <div class="header">
	      <p class="size">商户管理</p>
	     <el-button type="primary" class="button" @click="AddMerchant">+ 签约商户</el-button>
	    </div>
	    <el-form :inline="true"
				ref="formFind"
				:rules="rules"
				:model="formFind" class="form">
		 <div>
			 <el-form-item label="店铺名称:" prop="name">
			    <el-input v-model="formFind.name" placeholder="请输入要查询的店铺名称"></el-input>
			  </el-form-item>
			   <el-form-item label="手机号:" prop="phone">
			    <el-input v-model.trim.number="formFind.phone" placeholder="请输入要查询的手机号"></el-input>
			  </el-form-item>
		 </div>
		  <div style="margin-right: 20px;">
			 <el-button
			 	@click="findMerch"
			 	type="primary"
				style="height: 35px;line-height: 10px;">查询</el-button>
			  <el-button
					@click="resetForm"
					type="info"
					style="height: 35px;line-height: 10px;">重置</el-button>
		</div>
		</el-form>
		<el-table
			:header-cell-style="cell"
			:data="data"
	    stripe
			style="width: 100%;margin-top: 20px;">
			<el-table-column
				prop="name"
				label="店铺名称"
				align="center"
				>
			</el-table-column>

			<el-table-column
				prop="createTime"
				label="创建时间"
        :min-width="162"
				align="center"
				>
			</el-table-column>
				<el-table-column
				prop="phone"
				label="联系方式"
				align="center"
				>

			</el-table-column>
      <el-table-column
      :formatter="tofixed"
				prop="allIncome"
				label="总收入(元)"
				align="center"
				>
			</el-table-column>
			<el-table-column
      :formatter="tofixed"
				prop="account"
				label="润泽钱包余额(元)"
				align="center"
				>
			</el-table-column>
      <el-table-column
      :formatter="tofixed"
				prop="thirdAccount"
				label="第三方钱包余额(元)"
				align="center"
				>
			</el-table-column>
			<el-table-column
				prop="day"
				label="园区钱包结算周期"
				align="center"
				>
			</el-table-column>
      <el-table-column
				prop="thirdDay"
				label="第三方结算周期"
				align="center"
				>
			</el-table-column>
			<el-table-column label="操作"  width="250" align="center">
			<template slot-scope="scope" >
				<el-button
					size="medium"
					type="text"
					@click="handleCompile(scope.row.mchId,scope.row.account)">编辑</el-button>
				<el-button
					style="color: #333333"
					size="medium"
					type="text"
					@click="detail(scope.row.mchId,scope.row.name)">详情</el-button>
          <el-button
					style="color: #333333"
					size="medium"
					type="text"
					@click="downLoad(scope.row.mchId,scope.row.name)">二维码</el-button>
				<el-button
					style="color: red;"
					size="medium"
					type="text"
					@click="handleDelete(scope.row.name,scope.row.mchId,3)">删除</el-button>		
				<el-button
          v-if="1 == scope.row.status"
					style="color:red"
					size="medium"
					type="text"
          @click="handleDelete(scope.row.name,scope.row.mchId,2)"
					>封号</el-button>
				<el-button
          v-else-if="2 == scope.row.status"
					size="medium"
					type="text"
          @click="handleDelete(scope.row.name,scope.row.mchId,1)"
					>解封</el-button>
			</template>
			</el-table-column>
		</el-table>
	  <!-- 页码 -->
    <div class="pageWrap">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="count"
        @current-change="clickPage"
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { validateTel } from "@/utils/validate";
import { getMerList, deleteMch, getMerchantBycode } from "@/api/merchant/merchManage";
import { downloadPic } from "@/utils/downloadFetch";
import {shop_url} from '@/global';
import { toFixed } from "@/utils";
export default {
  name: "",
  props: [""],
  data() {
    const valiPhone = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!validateTel(value)) {
        return callback(new Error("请输入正确手机号"));
      } else {
        callback();
      }
    };
    return {
      currentPage: 1,
      count: 0,
      pageSize: 5,
      disableStauts: 2, //封号状态码
      formFind: {
        name: "",
        phone: ""
      },
      rules: {
        phone: [{ validator: valiPhone, trigger: "blur" }]
      },
      buttonn: {
        btnText: "隐藏",
        isShow: true,
        isSho: false
      },
      dialogFormVisible: false,
      Delete: false,
      jieFeng: false,
      name1: "",
      formLabelWidth: "120px",
      data: [],
      form: {
        name: "",
        region: ""
      }
    };
  },
  created() {
    this._getMerList();
  },
  methods: {
    // 添加商户
    AddMerchant() {
      this.$router.push({
        path: "/main/addMerchant"
      });
    },
    tofixed(row, column, cellValue) {
      return toFixed(cellValue);
    },
    // 查询
    findMerch() {
      this.$refs.formFind.validate(valid => {
        if (valid) {
          this.data = [];
          this.currentPage = 1;
          this._getMerList();
        }
      });
    },
    // 重置
    resetForm() {
      this.$refs.formFind.resetFields();
        this.currentPage = 1;
        this._getMerList();
    },
    onSubmit() {
      console.log("submit!");
    },
    handleCompile(mchId,account) {
      this.$router.push({
        path: "/main/addMerchant",
        query: { mchId ,account}
      });
    },
    detail(mchId,name) {
      this.$router.push({
        path: "/main/details",
        query: { id: mchId ,name: name}
      });
    },
    downLoad(mchId,name) {
      console.log(mchId,name)
      downloadPic({
        method: "get",
        fileName:name + '的二维码.jpg',
        url: `${shop_url}/shop/cms/QrcodeDown/`+mchId
      }).then(res => {
        console.log(res);
      });
      // location.href="/sps/cms/QrcodeDown/"+mchId;
    // 删除商户
    },
    handleDelete(name, id, type) {
      let msg = "";
      switch (type) {
        case 1:
          {
            msg = "是否解封 “" + name + "” ？";
          }
          break;
        case 2:
          {
            msg = "确定封号 “" + name + "” ，封号后可进行解封";
          }
          break;
        case 3:
          {
            msg = "确定删除企业 “" + name + " ”，删除后不可撤销";
          }
          break;
        default: {
          msg = "确认进行此操作？";
        }
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteMch(id, type)
            .then(res => {
              // if ("success" === res.data.msg) {
              // this.currentPage = 1;
              if (1 === type || 2 === type) {
                this._updateData(id, type);
              }
              this._getMerList(this.currentPage);
              this.$message({
                type: "success",
                message: "操作成功!"
              });
              // }
            })
            .catch(error => {
              let msg = "请求出错！";
              if (error.response.data) {
                msg = error.response.data.msg || "请求出错";
              }

              this.$message({
                type: "warning",
                message: msg
              });
            });
        })
        .catch(() => {
          switch (type) {
            case 1:
              {
                this.$message({
                  type: "info",
                  message: "已取消解封"
                });
              }
              break;
            case 2:
              {
                this.$message({
                  type: "info",
                  message: "已取消封号"
                });
              }
              break;
            case 3:
              {
                this.$message({
                  type: "info",
                  message: "已取消删除"
                });
              }
              break;
          }
        });
    },
    handleRino(index, row) {
      this.Rino = true;
      this.form.name = row.name;
    },
    RinoQ() {
      this.Rino = false;
      this.buttonn.isShow = !this.buttonn.isShow;
      this.buttonn.isSho = !this.buttonn.isSho;
    },
    clickPage(currentPage) {
      this.currentPage = currentPage;
      this._getMerList();
    },
    // 本地假更新数据
    _updateData(id, type) {
      let len = this.data.length;
      let updateData = this.data;
      let status = 0;
      for (let i = 0; i < len; i++) {
        let mchId = updateData[i].mchId;
        if (id === mchId) {
          updateData[i]["status"] = type;
        }
      }
      this.data = updateData;
    },
    // 分页查询商户列表
    _getMerList(isFind) {
      getMerList(
        this.currentPage,
        this.pageSize,
        this.formFind.name,
        this.formFind.phone
      )
        .then(res => {
          //避免删除最后一条跳页问题
          if(res.data.msg=="未查询到任何数据"){
                for (let prop in res.data) {
                  this[prop] = res.data[prop];
                }
          }else {
            let len = res.data.data.length;
              for(var i=0;i<len;i++){
                  res.data.data[i].day= "T+" + res.data.data[i].day + " " + res.data.data[i].feeRate + "%"
                  res.data.data[i].thirdDay= "T+" + res.data.data[i].thirdDay + " " + parseFloat(res.data.data[i].thirdFeeRate)*100  + "%"
                }
              for (let prop in res.data) {
                this[prop] = res.data[prop];
              }
          }
    
        })
        .catch(error => {
          //this._notify("请求出错,请重试", "warning");
            // this.$message({
            //   type:"error",
            //   message:"抱歉，您没有当前模块的访问权限"
            // })
        });
    },
    cell() {
      return { textAlign: "center" ,background:"#FAFAFA"};
    },
    //通知框
    _notify(message = "提示", type = "success") {
      this.$notify({
        title: "提示",
        message,
        type,
        duration: 3000
      });
    }
  }
};
</script>
<style scoped lang='scss'>
.header {
  display: flex;
  justify-content: space-between;
}
.pageWrap {
  margin-top: 20px;
  .el-pagination {
    text-align: center;
    
  }
}
.button {
  height: 35px;
  line-height: 10px;
  margin-right: 20px;
}
.size {
  font-size: 18px;
}
.form {
  text-align: left;
  display: flex;
  justify-content: space-between;
}
.select {
  height: 35px;
  line-height: 10px;
}
.reset {
  height: 35px;
  line-height: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/merchant/index.vue